export type Maybe<T> = T | null;

export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  // Void: any;
};
export enum MeetingType {
  Hybrid = 'Hybrid',
  Online = 'Online',
  Physical = 'Physical',
}

export type PresidentialRepresentative = {
  firstName: Scalars['String'];
  id: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
};

export type ParticipatingDistricts = {
  id: Scalars['String'];
  riDistrictId: Scalars['String'];
};

export type ConferenceFeedbackResult = {
  id: Scalars['String'];
  type: Scalars['String'];
};

export type ConferenceAddress = {
  city?: string | null | undefined;
  country?: string | null | undefined;
  internationalProvince?: string | null | undefined;
  lineOne?: string | null | undefined;
  lineThree?: string | null | undefined;
  lineTwo?: string | null | undefined;
  postalCode?: string | null | undefined;
  state?: string | null | undefined;
};

export type GetConferencesResult = {
  id: Scalars['String'];
  districtId?: Maybe<Scalars['String']>;
  nfKey?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  relatedRotaryYear?: Maybe<Scalars['String']>;
  venueName?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  prAccommodation?: Maybe<Scalars['String']>;
  locationCityState?: Maybe<Scalars['String']>;
  locationCountry?: Maybe<Scalars['String']>;
  locationNameEng?: Maybe<Scalars['String']>;
  locationCityStateEng?: Maybe<Scalars['String']>;
  presRepresentativeHotel?: Maybe<Scalars['String']>;
  presRepresentativeHotelAddress?: Maybe<Scalars['String']>;
  presRespresntativeHotelPhone?: Maybe<Scalars['String']>;
  prComment?: Maybe<Scalars['String']>;
  govComment?: Maybe<Scalars['String']>;
  venueType?: Maybe<MeetingType>;
  conferenceAddress?: Maybe<ConferenceAddress>;
  onlineLocation?: Maybe<Scalars['String']>;
  locationNameOrDetail?: Maybe<Scalars['String']>;
  detailForJoiningRemotely?: Maybe<Scalars['String']>;
  prAddress?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Scalars['String']>;
  isPresRepRequested?: Maybe<Scalars['Boolean']>;
  presRepAccPhone?: Maybe<Scalars['String']>;
  createdByRiDistrictId?: Maybe<Scalars['String']>;
  feedbacks: Array<ConferenceFeedbackResult>;
  isDistrictPresRep?: Maybe<Scalars['Boolean']>;
  participatingDistricts?: Maybe<Array<ParticipatingDistricts>>;
  presidentialRepresentative?: Maybe<PresidentialRepresentative>;
};

export type GetConferencesResults = GetConferencesResult[];

/** User's access level for an operations. */
export enum AccessLevel {
  /** Can edit, but some fields are restricted. */
  Contributor = 'Contributor',
  LimitedViewer = 'LimitedViewer',
  /** Can edit everything. */
  Manager = 'Manager',
  NoPermission = 'NoPermission',
  Viewer = 'Viewer',
}

export type GetAccessLevelsQuery = {
  data: Array<{
    target: string;
    level: AccessLevel;
    arguments?:
      | {
          targetTermYear?: string | null | undefined;
          type?: string | null | undefined;
        }
      | null
      | undefined;
  }>;
};

export type AccessLevelsArguments = {
  targetDistrictId?: Maybe<Scalars['String']>;
  targetTermYear?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type GetAccessLevelsResults = {
  arguments?: Maybe<AccessLevelsArguments>;
  level: AccessLevel;
  target: Scalars['String'];
};

export type ConferencesAccessLvl = {
  id: string;
  level: AccessLevel;
  targetTermYear: string;
};

export enum ACCESS_LEVEL_TARGETS {
  DISTRICT_LEADERSHIP = 'DistrictLeadership',
  DISTRICT_DASHBOARDS = 'DistrictDashboards',
  DISTRICT_CONFERENCES = 'DistrictConferences',
  DISTRICT_CONFERENCE_FEEDBACK = 'DistrictConferenceFeedback',
}

export type ParticipantOption = {
  id: string;
  value: number;
};
export interface ParticipatingDistrict {
  id: string;
  riDistrictId: number;
}

export interface AddressBaseOutput {
  id?: string | null;
  state: string | null;
  country: string | null;
  lineOne: string | null;
  city: string | null;
  postalCode: string | null;
  countryId: string;
  internationalProvince: string | null;
  lineThree: string | null;
  lineTwo: string | null;
  stateId: string | null;
}

export interface PhoneInput {
  phoneType: string;
  countryId: string;
  extension: string | null;
  number: string;
}
export interface DistrictConference {
  id: string;
  districtId: string;
  startDate: string;
  startTime: string;
  endDate: string;
  endTime: string;
  timeZone: string;
  relatedRotaryYear: number;
  venueName: string;
  language: string;
  prAccommodation: string;
  prComment: string;
  govComment: string;
  participatingDistricts: ParticipatingDistrict[];
  venueType: MeetingType;
  onlineLocation: string;
  locationNameOrDetail: string;
  detailForJoiningRemotely: string;
  conferenceAddress: AddressBaseOutput;
  prAddress: AddressBaseOutput;
  presidentialRepresentative: PresidentialRepresentative;
  isPresRepRequested: boolean;
  presRepAccPhone: PhoneInput;
}

export type DistrictPresRepsFeebacks = {
  term: Scalars['Int'];
  districtId: Scalars['String'];
  riDistrictId: Scalars['Int'];
  conferences: Array<GetConferencesResult>;
  feedbacks?: Array<ConferenceFeedbackResult>;
};

export type InputFeedbackSection = {
  id: Scalars['String'];
  sectionName: Scalars['String'];
};

export type InputOptionDetail = {
  id: Scalars['String'];
  optionValue: Scalars['String'];
};

export type InputOptionType = {
  id: Scalars['String'];
  optionType: Scalars['String'];
};

export type InputQuestion = {
  applicationFeature: Scalars['String'];
  applicationId: Scalars['String'];
  feedbackSection: InputFeedbackSection;
  id: Scalars['String'];
  option: Scalars['String'];
  optionDataType: Scalars['String'];
  optionDetail: InputOptionDetail;
  optionSeq: Scalars['Int'];
  optionType: InputOptionType;
};

export type FetchDgByRyQuery = {
  riDistrictId: string;
  rolename: string;
  fullName: string;
};
